import { ISlopedGabionResults } from '../../../../api/IApiResponse';
import { IProjectMacra2 } from '../../../../store/project/projectSlice';
import { IChannelGeometrySlopedWeirForm } from '../../../InputForm/ChannelGeometry/IChannelGeometry';
import { IStillingBasinSteppedWeirSlopedWeirForm } from '../../../InputForm/StillingBasin/IStillingBasin';
import { IWeirGeometrySlopedWeirForm } from '../../../InputForm/WeirGeometry/IWeirGeometry';
import { IWingsGeometrySlopedWeirForm } from '../../../InputForm/WingsGeometry/IWingsGeometry';

export interface ISlopedWeirLongitudinalProps {
    wingsGeometry: IWingsGeometrySlopedWeirForm;
    weirGeometry: IWeirGeometrySlopedWeirForm;
    stillingBasin: IStillingBasinSteppedWeirSlopedWeirForm;
    result?: ISlopedGabionResults;
    inspectAttribute: (width: number, height: number) => void;
    scale: number;
    isImperial: boolean;
}

export interface ISlopedWeirCrossProps {
    wingsGeometry: IWingsGeometrySlopedWeirForm;
    weirGeometry: IWeirGeometrySlopedWeirForm;
    riverGeometry: IChannelGeometrySlopedWeirForm;
    scale: number;
    result?: ISlopedGabionResults;
    isImperial: boolean;
}

export enum EStepRatio {
    oneToOne = 1 / 1,
    oneToTwo = 1 / 2,
    oneToThree = 1 / 3,
}

export enum ELiningThickness {
    zeroPointSeventeen = 0.17,
    zeroPointTwentyThree = 0.23,
    zeroPointThirty = 0.3,
    zeroPointFive = 0.5,
    zeroPointSix = 0.6,
    one = 1,
}
export enum ELiningThicknessImp {
    zeroPointFiftyFive = 0.55,
    zeroPointSeventyFive = 0.75,
    one = 1,
    oneAndHalf = 1.5,
    three = 3,
}
